import {
  UtilitySelect,
  Icon,
  useTheme,
  Option,
} from '@quickbit/qb-design-system';
import { usePlatformApi } from 'api/usePlatformApi';

interface Props {
  platform: Option | null;
  setPlatform: (data: (Option & { merchants: Option[] }) | null) => void;
  searchable?: boolean;
}

export const PlatformSelect = ({
  platform,
  setPlatform,
  searchable = true,
}: Props) => {
  const { palette } = useTheme();
  const { getPlatformList } = usePlatformApi();
  const { data: platforms, isPending } = getPlatformList();

  if (isPending)
    return (
      <Icon
        name="spinner"
        className={{ svg: { color: palette.grey.default } }}
      />
    );

  const platformOptions = platforms?.map((platform) => ({
    value: platform.uuid || '',
    label: platform.name,
    merchants: platform.merchants,
  }));

  return (
    <UtilitySelect
      label={platform ? platform.label : 'Platforms'}
      listTitle="Platforms"
      options={platformOptions ?? []}
      value={platform}
      onSelect={(o) => {
        if (Array.isArray(o)) return;
        if (o === null) {
          setPlatform(null);
        } else {
          const selected = platformOptions?.find((p) => p.value === o.value);
          if (!selected) return;
          setPlatform({
            ...selected,
            merchants: selected.merchants.map((m) => ({
              label: m.name,
              value: m.merchantId,
            })),
          });
        }
      }}
      searchable={searchable}
    />
  );
};
